import { apiGet } from 'api';
import {
  GetIncomingConsultationsRequest,
  GetIncomingConsultationsResponse,
} from '../fragments';

export const getIncomingConsultations = (
  request: GetIncomingConsultationsRequest
): Promise<GetIncomingConsultationsResponse> =>
  apiGet<GetIncomingConsultationsResponse, GetIncomingConsultationsRequest>(
    'admin/incomingconsultations',
    request
  );
